export const ENTRIES_RESOURCE_NAME = 'focus_group_entries';

export const MAX_COMMENT_LENGTH = 500;



// WEBPACK FOOTER //
// ./focus_groups/constants.js